import Projects from './projects';
export default Projects;